import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";

import "../../styles/common.css";
import "../../styles/legal.css";

const Impressum = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='impressum'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Impressum</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/en">Home</a></li>
                <li aria-current="page">Impressum</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='legal'>
          <div className='legal-box'>
            <h2>Angaben gemäß § 5 TMG:</h2>
            <div className='legal-box__text'>
              <p><b>LOGOT UG</b></p>
              <p>Moerser Str 125 Im Hof, 40667 Meerbusch, Deutschland</p>
              <p>E-Mail: <a href="mailto:contact@logot.de" className='button-underLine' target="_blank">contact@logot.de</a></p>
              <p>Website: <a href="/en" className='button-underLine'>logot.de</a></p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>Vertreten durch:</h2>
            <div className='legal-box__text'>
              <p>Shinzo Hata, Ko Watanabe</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>Registereintrag:</h2>
            <div className='legal-box__text'>
              <p>Eintragung im Handelsregister.</p>
              <p>Registergericht: Amtsgericht Düsseldorf</p>
              <p>Registernummer: HRB 106102</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>Umsatzsteuer-ID:</h2>
            <div className='legal-box__text'>
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:</p>
              <p>DE369420397</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>Berufsbezeichnung und berufsrechtliche Regelungen (falls zutreffend)</h2>
            <div className='legal-box__text'>
              <p>Berufsbezeichnung: Webentwickler: Ko Watanabe</p>
              <p>Zuständige Kammer: IHK Musterstadt</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>Haftungsausschluss:<br />Haftung für Inhalte:</h2>
            <div className='legal-box__text'>
              <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>Haftung für Links:</h2>
            <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.</p>
          </div>
          <div className='legal-box'>
            <h2>Alternative Streitbeilegung:</h2>
            <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" className='button-underLine' target="_blank">https://ec.europa.eu/consumers/odr</a></p>
            <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          </div>
        </section>
      </main >
      <Footer></Footer>
    </>
  );
};

export default Impressum